import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import HistorySection from '../components/History/History';
import Footer from '../components/Footer/Footer2';

class History extends Component {
    render() {
        return (
            <div className="main">
                <HistorySection />
                <Footer />
            </div>
        );
    }
}

export default withRouter(History);